import { useRef, useEffect, useMemo } from "react";

/**
 * 计算内部view的高度比例
 * @param percent
 */
export function useHandleScale(percent: number) {
  const height = useMemo(() => {
    return percent * 2 + "%";
  }, [percent]);
  return height;
}

/**
 * 用于初始化时，滚动日视图和周视图到8点位置
 */
export function useInitScrollView() {
  const divEl = useRef(null);
  useEffect(() => {
    const curr: any = divEl.current;
    if (curr) {
      const scrollHeight = curr.scrollHeight;
      if (!scrollHeight) {
        return;
      }
      const scrollTop = Math.floor(scrollHeight / 3);
      curr.scrollTop = scrollTop;
      // console.log('curr---', curr.scrollHeight, curr.scrollTop, scrollTop, curr);
    }
  }, []);
  return divEl;
}
